(function () {
  'use strict';
  var version = 'MOUSTACHE_EXACT_VARIANT_TECHNICAL_V1';
  var scheduled = false;
  var original = new WeakMap();
  var labels = {cuadro:'frame',horquilla:'fork',amortiguador:'rear_shock',motor:'motor',bateria:'battery',pantalla:'display',mandoremoto:'display',cambiotrasero:'rear_derailleur',cassette:'cassette',cadena:'chain',bielas:'crankset',crankset:'crankset',frenodelantero:'brakes',frenotrasero:'brakes',cubiertadelantera:'tires',cubiertatrasera:'tires',tijadelsillin:'seatpost',potencia:'stem',manillar:'handlebar',sillin:'saddle'};
  function normal(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, ''); }
  function setText(node, text) { if (node.textContent !== text) node.textContent = text; }
  function valueFor(specs, key) {
    var value = specs[key];
    if (value === undefined || value === null || value === '') return '';
    return String(value) + (key === 'motor_nm' ? ' Nm' : key === 'weight_kg' ? ' kg' : '');
  }
  function update() {
    scheduled = false;
    var data = document.querySelector('[data-lbx-exact-variant-profiles]');
    var root = document.querySelector('.lbx-product-pro');
    var input = root && root.querySelector('[data-lbx-variant-id]');
    if (!data || !input) return;
    var profiles;
    try { profiles = JSON.parse(data.textContent); } catch (_) { return; }
    var profile = profiles[String(input.value)];
    if (!profile || profile.version !== version || !profile.specifications) return;
    var specs = profile.specifications;
    var summary = root.querySelector('.lbx-description');
    if (summary && profile.description) setText(summary, profile.description.length > 190 ? profile.description.slice(0,187) + '…' : profile.description);
    document.querySelectorAll('[data-lbx-exact-spec]').forEach(function (node) {
      if (!original.has(node)) original.set(node, node.textContent);
      setText(node, valueFor(specs, node.getAttribute('data-lbx-exact-spec')));
    });
    document.querySelectorAll('[data-lbx-exact-summary]').forEach(function (node) { if (profile.description) setText(node, profile.description); });
    document.querySelectorAll('[data-lbx-exact-assistance]').forEach(function (node) { setText(node, [specs.motor, specs.battery].filter(Boolean).join(' · ')); });
    document.querySelectorAll('[data-lbx-exact-overview]').forEach(function (node) {
      var parts = [profile.description];
      if (specs.fork) parts.push('Horquilla: ' + specs.fork + '.');
      if (specs.brakes) parts.push('Frenos: ' + specs.brakes + '.');
      setText(node, parts.filter(Boolean).join(' '));
    });
    document.querySelectorAll('[data-lbx-exact-description], .lbx-product-description-details__content').forEach(function (body) {
      var first = body.querySelector('p');
      if (first && profile.description) setText(first, profile.description);
      body.querySelectorAll('dt').forEach(function (term) {
        var key = labels[normal(term.textContent)];
        var definition = term.nextElementSibling;
        if (!key || !definition || definition.tagName !== 'DD') return;
        var sourceLabel = Object.keys(profile.fields || {}).find(function (label) { return normal(label) === normal(term.textContent); });
        var value = sourceLabel ? String(profile.fields[sourceLabel]) : valueFor(specs, key);
        term.hidden = !value; definition.hidden = !value;
        if (value) setText(definition, value);
      });
    });
  }
  function queue() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { window.requestAnimationFrame(update); });
  }
  function init() {
    var root = document.querySelector('.lbx-product-pro');
    if (!root || root.hasAttribute('data-lbx-exact-profile-ready')) return;
    root.setAttribute('data-lbx-exact-profile-ready', 'true');
    new MutationObserver(queue).observe(root, {subtree:true,childList:true,attributes:true,attributeFilter:['value','aria-pressed','class']});
    document.addEventListener('change', queue);
    document.addEventListener('click', queue);
    document.addEventListener('variant:change', queue);
    window.addEventListener('popstate', queue);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', function () { init(); queue(); });
})();
